import { TicketsOpenComponent } from './tickets-open/tickets-open.component';
import { TicketsInProgressComponent } from './tickets-in-progress/tickets-in-progress.component';
import { TicketsResolvedComponent } from './tickets-resolved/tickets-resolved.component';
import { TicketsClosedComponent } from './tickets-closed/tickets-closed.component';
import { NewTicketsCreatedComponent } from './new-tickets-created/new-tickets-created.component';
//import { FirstResponseTimeComponent } from './first-response-time/first-response-time.component';
//import { AveResolutionTimeComponent } from './ave-resolution-time/ave-resolution-time.component';
import { CustomerSatisfactionComponent } from './customer-satisfaction/customer-satisfaction.component';
//import { SlaMonitoringComponent } from './sla-monitoring/sla-monitoring.component';
import { TicketsSolvedAndCleatedComponent } from './tickets-solved-and-cleated/tickets-solved-and-cleated.component';
import { PerformanceOfAgentsComponent } from './performance-of-agents/performance-of-agents.component';
import { TicketsByChannelComponent } from './tickets-by-channel/tickets-by-channel.component';
import { TicketsByTypeComponent } from './tickets-by-type/tickets-by-type.component';
//import { RecentCustomerRatingComponent } from './recent-customer-rating/recent-customer-rating.component';

import { Component, ViewChild } from '@angular/core';
import { NgFor } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule } from '@ngneat/transloco';
import { ApiService } from '../../services/api/api.service';
import { Company } from '../../interfaces/Company';
import { CompanyResponse } from '../../interfaces/CompanyResponse';
import { BranchOffice } from './../../interfaces/BranchOffice';
import { BranchOfficeResponse } from './../../interfaces/BranchOfficeResponse';
import { DashboardResponse } from '../../interfaces/DashboardResponse';
import { GlobalConstants } from '../../common/global-constants';

@Component({
    selector: 'app-help-desk',
    standalone: true,
    imports: [
        TicketsOpenComponent,
        TicketsInProgressComponent,
        TicketsResolvedComponent,
        TicketsClosedComponent,
        NewTicketsCreatedComponent,
        //FirstResponseTimeComponent,
        //AveResolutionTimeComponent,
        CustomerSatisfactionComponent,
        //SlaMonitoringComponent,
        TicketsSolvedAndCleatedComponent,
        PerformanceOfAgentsComponent,
        TicketsByChannelComponent,
        TicketsByTypeComponent,
       // RecentCustomerRatingComponent,
        MatButtonModule,
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        ReactiveFormsModule,
        TranslocoModule,
        NgFor,
    ],
    templateUrl: './help-desk.component.html',
    styleUrl: './help-desk.component.scss',
})
export class HelpDeskComponent {
    // Array of companies
    companies: Company[] = [];

    selectedCompany: string = '';

    // Array of branch offices
    branchOffices: BranchOffice[] = [];

    selectedBranchOffice: string = '';

    @ViewChild('kpiViewOpenVulnerabilities', { static: false })
    kpiViewOpenVulnerabilities: TicketsOpenComponent;

    @ViewChild('kpiViewAllOpenVulnerabilitiesWithoutManagement', {
        static: false,
    })
    kpiViewAllOpenVulnerabilitiesWithoutManagement: TicketsInProgressComponent;

    @ViewChild('kpiViewAllVulnerabilities', { static: false })
    kpiViewAllVulnerabilities: TicketsResolvedComponent;

    @ViewChild('kpiViewAllClosedVulnerabilities', { static: false })
    kpiViewAllClosedVulnerabilities: TicketsClosedComponent;

    @ViewChild('kpiVulnerabilitiesByCriticality', { static: false })
    kpiVulnerabilitiesByCriticality: NewTicketsCreatedComponent;

    @ViewChild('multipleKpiSeriesVulnerabilityVersus', { static: false })
    multipleKpiSeriesVulnerabilityVersus: TicketsSolvedAndCleatedComponent;

    @ViewChild('tableVulnerabilityAssessmentBySupervisorAndSeverity', {
        static: false,
    })
    tableVulnerabilityAssessmentBySupervisorAndSeverity: PerformanceOfAgentsComponent;

    @ViewChild('pieVulnerabilitiesBySeverityLevel', { static: false })
    pieVulnerabilitiesBySeverityLevel: CustomerSatisfactionComponent;

    @ViewChild('pieVulnerabilitiesOpenBySeverityLevel', { static: false })
    pieVulnerabilitiesOpenBySeverityLevel: TicketsByChannelComponent;

    @ViewChild('pieVulnerabilitiesClosedBySeverityLevel', { static: false })
    pieVulnerabilitiesClosedBySeverityLevel: TicketsByTypeComponent;

    specialist = GlobalConstants.specialist;

    constructor(private apiService: ApiService) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for role name
     */
    get roleName(): string {
        return localStorage.getItem('roleName') ?? '';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * ngOnInit
     */
    ngOnInit() {
        console.log(this.roleName);
        switch (this.roleName) {
            case GlobalConstants.specialist:
                this.apiService
                    .getDashboardByChart('kpiViewOpenVulnerabilities')
                    .subscribe((response: DashboardResponse) => {
                        if (response.singleKPIViewChartDTO) {
                            this.kpiViewOpenVulnerabilities.data.name =
                                response.singleKPIViewChartDTO.name;
                            this.kpiViewOpenVulnerabilities.data.amounts =
                                response.singleKPIViewChartDTO.amounts;
                            this.kpiViewOpenVulnerabilities.data.dates =
                                response.singleKPIViewChartDTO.dates;
                            this.kpiViewOpenVulnerabilities.changeData();
                        }
                    });

                this.apiService
                    .getDashboardByChart(
                        'kpiViewAllOpenVulnerabilitiesWithoutManagement'
                    )
                    .subscribe((response: DashboardResponse) => {
                        if (response.singleKPIViewChartDTO) {
                            this.kpiViewAllOpenVulnerabilitiesWithoutManagement.data.name =
                                response.singleKPIViewChartDTO.name;
                            this.kpiViewAllOpenVulnerabilitiesWithoutManagement.data.amounts =
                                response.singleKPIViewChartDTO.amounts;
                            this.kpiViewAllOpenVulnerabilitiesWithoutManagement.data.dates =
                                response.singleKPIViewChartDTO.dates;
                            this.kpiViewAllOpenVulnerabilitiesWithoutManagement.changeData();
                        }
                    });

                this.apiService
                    .getDashboardByChart('kpiViewAllVulnerabilities')
                    .subscribe((response: DashboardResponse) => {
                        if (response.singleKPIViewChartDTO) {
                            this.kpiViewAllVulnerabilities.data.name =
                                response.singleKPIViewChartDTO.name;
                            this.kpiViewAllVulnerabilities.data.amounts =
                                response.singleKPIViewChartDTO.amounts;
                            this.kpiViewAllVulnerabilities.data.dates =
                                response.singleKPIViewChartDTO.dates;
                            this.kpiViewAllVulnerabilities.changeData();
                        }
                    });

                this.apiService
                    .getDashboardByChart('kpiViewAllClosedVulnerabilities')
                    .subscribe((response: DashboardResponse) => {
                        if (response.singleKPIViewChartDTO) {
                            this.kpiViewAllClosedVulnerabilities.data.name =
                                response.singleKPIViewChartDTO.name;
                            this.kpiViewAllClosedVulnerabilities.data.amounts =
                                response.singleKPIViewChartDTO.amounts;
                            this.kpiViewAllClosedVulnerabilities.data.dates =
                                response.singleKPIViewChartDTO.dates;
                            this.kpiViewAllClosedVulnerabilities.changeData();
                        }
                    });

                this.apiService
                    .getDashboardByChart('kpiVulnerabilitiesByCriticality')
                    .subscribe((response: DashboardResponse) => {
                        if (response.singleKPIViewChartDTO) {
                            this.kpiVulnerabilitiesByCriticality.data.name =
                                response.singleKPIViewChartDTO.name;
                            this.kpiVulnerabilitiesByCriticality.data.series =
                                response.singleKPIViewChartDTO.CVSS.series;
                            this.kpiVulnerabilitiesByCriticality.data.dates =
                                response.singleKPIViewChartDTO.CVSS.dates;
                            this.kpiVulnerabilitiesByCriticality.changeData();
                        }
                    });

                this.apiService
                    .getDashboardByChart('multipleKpiSeriesVulnerabilityVersus')
                    .subscribe((response: DashboardResponse) => {
                        if (response.singleKPIViewChartDTO) {
                            this.multipleKpiSeriesVulnerabilityVersus.data.name =
                                response.singleKPIViewChartDTO.name;
                            this.multipleKpiSeriesVulnerabilityVersus.data.categories =
                                response.singleKPIViewChartDTO.categories;
                            this.multipleKpiSeriesVulnerabilityVersus.data.series =
                                response.singleKPIViewChartDTO.series;
                            this.pieVulnerabilitiesClosedBySeverityLevel.changeData();
                        }
                    });

                this.apiService
                    .getDashboardByChart(
                        'tableVulnerabilityAssessmentBySupervisorAndSeverity'
                    )
                    .subscribe((response: DashboardResponse) => {
                        if (response.singleKPIViewChartDTO) {
                            this.tableVulnerabilityAssessmentBySupervisorAndSeverity.name =
                                response.singleKPIViewChartDTO.name;
                            this.tableVulnerabilityAssessmentBySupervisorAndSeverity.data =
                                response.singleKPIViewChartDTO.values;
                        }
                    });

                this.apiService
                    .getDashboardByChart('pieVulnerabilitiesBySeverityLevel')
                    .subscribe((response: DashboardResponse) => {
                        if (response.singleKPIViewChartDTO) {
                            this.pieVulnerabilitiesBySeverityLevel.data.name =
                                response.singleKPIViewChartDTO.name;
                            this.pieVulnerabilitiesBySeverityLevel.data.labels =
                                response.singleKPIViewChartDTO.labels;
                            this.pieVulnerabilitiesBySeverityLevel.data.series =
                                response.singleKPIViewChartDTO.series;
                            this.pieVulnerabilitiesBySeverityLevel.data.colors =
                                response.singleKPIViewChartDTO.colors;
                            this.pieVulnerabilitiesBySeverityLevel.changeData();
                        }
                    });

                this.apiService
                    .getDashboardByChart(
                        'pieVulnerabilitiesOpenBySeverityLevel'
                    )
                    .subscribe((response: DashboardResponse) => {
                        if (response.singleKPIViewChartDTO) {
                            this.pieVulnerabilitiesOpenBySeverityLevel.data.name =
                                response.singleKPIViewChartDTO.name;
                            this.pieVulnerabilitiesOpenBySeverityLevel.data.labels =
                                response.singleKPIViewChartDTO.labels;
                            this.pieVulnerabilitiesOpenBySeverityLevel.data.series =
                                response.singleKPIViewChartDTO.series;
                            this.pieVulnerabilitiesOpenBySeverityLevel.data.colors =
                                response.singleKPIViewChartDTO.colors;
                            this.pieVulnerabilitiesOpenBySeverityLevel.changeData();
                        }
                    });

                this.apiService
                    .getDashboardByChart(
                        'pieVulnerabilitiesClosedBySeverityLevel'
                    )
                    .subscribe((response: DashboardResponse) => {
                        if (response.singleKPIViewChartDTO) {
                            this.pieVulnerabilitiesClosedBySeverityLevel.data.name =
                                response.singleKPIViewChartDTO.name;
                            this.pieVulnerabilitiesClosedBySeverityLevel.data.labels =
                                response.singleKPIViewChartDTO.labels;
                            this.pieVulnerabilitiesClosedBySeverityLevel.data.series =
                                response.singleKPIViewChartDTO.series;
                            this.pieVulnerabilitiesClosedBySeverityLevel.data.colors =
                                response.singleKPIViewChartDTO.colors;
                            this.pieVulnerabilitiesClosedBySeverityLevel.changeData();
                        }
                    });
                break;
            case GlobalConstants.supervisor:
                this.apiService
                    .getCompanyByCompanyUser()
                    .subscribe((response: CompanyResponse) => {
                        this.companies.push(response.company);
                        this.selectedCompany = response.company.id;
                        this.changeCompany(this.selectedCompany);
                    });
                break;
            case GlobalConstants.manager:
                this.apiService
                    .getCompanyByCompanyUser()
                    .subscribe((response: CompanyResponse) => {
                        this.companies.push(response.company);
                        this.selectedCompany = response.company.id;
                        this.changeCompany(this.selectedCompany);
                    });
                break;
            default:
                this.apiService
                    .getCompanyPagination(0, 1000000, 'name', 'asc')
                    .subscribe((response: CompanyResponse) => {
                        this.companies.push(...response.companies);
                    });
        }
    }

    // clean data
    cleanData() {
        this.branchOffices = [];
        this.kpiViewOpenVulnerabilities.data.name = '';
        this.kpiViewOpenVulnerabilities.data.amounts = [];
        this.kpiViewOpenVulnerabilities.data.dates = [];
        this.kpiViewOpenVulnerabilities.changeData();
        this.kpiViewAllOpenVulnerabilitiesWithoutManagement.data.name = '';
        this.kpiViewAllOpenVulnerabilitiesWithoutManagement.data.amounts = [];
        this.kpiViewAllOpenVulnerabilitiesWithoutManagement.data.dates = [];
        this.kpiViewAllOpenVulnerabilitiesWithoutManagement.changeData();
        this.kpiViewAllVulnerabilities.data.name = '';
        this.kpiViewAllVulnerabilities.data.amounts = [];
        this.kpiViewAllVulnerabilities.data.dates = [];
        this.kpiViewAllVulnerabilities.changeData();
        this.kpiViewAllClosedVulnerabilities.data.name = '';
        this.kpiViewAllClosedVulnerabilities.data.amounts = [];
        this.kpiViewAllClosedVulnerabilities.data.dates = [];
        this.kpiViewAllClosedVulnerabilities.changeData();
        this.kpiVulnerabilitiesByCriticality.data.name = '';
        this.kpiVulnerabilitiesByCriticality.data.series = [];
        this.kpiVulnerabilitiesByCriticality.data.dates = [];
        this.kpiVulnerabilitiesByCriticality.changeData();
        this.pieVulnerabilitiesBySeverityLevel.data.name = '';
        this.pieVulnerabilitiesBySeverityLevel.data.labels = [];
        this.pieVulnerabilitiesBySeverityLevel.data.series = [];
        this.pieVulnerabilitiesBySeverityLevel.changeData();
        this.pieVulnerabilitiesOpenBySeverityLevel.data.name = '';
        this.pieVulnerabilitiesOpenBySeverityLevel.data.labels = [];
        this.pieVulnerabilitiesOpenBySeverityLevel.data.series = [];
        this.pieVulnerabilitiesOpenBySeverityLevel.changeData();
        this.pieVulnerabilitiesClosedBySeverityLevel.data.name = '';
        this.pieVulnerabilitiesClosedBySeverityLevel.data.labels = [];
        this.pieVulnerabilitiesClosedBySeverityLevel.data.series = [];
        this.pieVulnerabilitiesClosedBySeverityLevel.changeData();
        this.multipleKpiSeriesVulnerabilityVersus.data.name = '';
        this.multipleKpiSeriesVulnerabilityVersus.data.categories = [];
        this.multipleKpiSeriesVulnerabilityVersus.data.series = [];
        this.multipleKpiSeriesVulnerabilityVersus.changeData();
    }

    // Change company
    changeCompany(companyId: string) {
        this.cleanData();
        if (this.roleName != GlobalConstants.internal) {
            this.apiService
                .getBranchOfficeByCompany(0, 1000000, 'name', 'asc')
                .subscribe((response: BranchOfficeResponse) => {
                    if (response.branchOffices.length > 0) {
                        this.branchOffices.push(...response.branchOffices);
                        this.selectedBranchOffice = '';
                    }
                });
        } else {
            this.apiService
                .getBranchOfficeByCompanyId(
                    companyId,
                    0,
                    1000000,
                    'name',
                    'asc'
                )
                .subscribe((response: BranchOfficeResponse) => {
                    if (response.branchOffices.length > 0) {
                        this.branchOffices.push(...response.branchOffices);
                        this.selectedBranchOffice = '';
                    }
                });
        }
    }

    // Change Branch Office
    changeBranchOffice(branchOfficeId: string) {
        const isInternal = this.roleName == GlobalConstants.internal;
        this.apiService
            .getDashboardByBranchOficceId(
                'kpiViewOpenVulnerabilities',
                branchOfficeId,
                isInternal
            )
            .subscribe((response: DashboardResponse) => {
                if (response.singleKPIViewChartDTO) {
                    this.kpiViewOpenVulnerabilities.data.name =
                        response.singleKPIViewChartDTO.name;
                    this.kpiViewOpenVulnerabilities.data.amounts =
                        response.singleKPIViewChartDTO.amounts;
                    this.kpiViewOpenVulnerabilities.data.dates =
                        response.singleKPIViewChartDTO.dates;
                    this.kpiViewOpenVulnerabilities.changeData();
                }
            });

        this.apiService
            .getDashboardByBranchOficceId(
                'kpiViewAllOpenVulnerabilitiesWithoutManagement',
                branchOfficeId,
                isInternal
            )
            .subscribe((response: DashboardResponse) => {
                if (response.singleKPIViewChartDTO) {
                    this.kpiViewAllOpenVulnerabilitiesWithoutManagement.data.name =
                        response.singleKPIViewChartDTO.name;
                    this.kpiViewAllOpenVulnerabilitiesWithoutManagement.data.amounts =
                        response.singleKPIViewChartDTO.amounts;
                    this.kpiViewAllOpenVulnerabilitiesWithoutManagement.data.dates =
                        response.singleKPIViewChartDTO.dates;
                    this.kpiViewAllOpenVulnerabilitiesWithoutManagement.changeData();
                }
            });

        this.apiService
            .getDashboardByBranchOficceId(
                'kpiViewAllVulnerabilities',
                branchOfficeId,
                isInternal
            )
            .subscribe((response: DashboardResponse) => {
                if (response.singleKPIViewChartDTO) {
                    this.kpiViewAllVulnerabilities.data.name =
                        response.singleKPIViewChartDTO.name;
                    this.kpiViewAllVulnerabilities.data.amounts =
                        response.singleKPIViewChartDTO.amounts;
                    this.kpiViewAllVulnerabilities.data.dates =
                        response.singleKPIViewChartDTO.dates;
                    this.kpiViewAllVulnerabilities.changeData();
                }
            });

        this.apiService
            .getDashboardByBranchOficceId(
                'kpiViewAllClosedVulnerabilities',
                branchOfficeId,
                isInternal
            )
            .subscribe((response: DashboardResponse) => {
                if (response.singleKPIViewChartDTO) {
                    this.kpiViewAllClosedVulnerabilities.data.name =
                        response.singleKPIViewChartDTO.name;
                    this.kpiViewAllClosedVulnerabilities.data.amounts =
                        response.singleKPIViewChartDTO.amounts;
                    this.kpiViewAllClosedVulnerabilities.data.dates =
                        response.singleKPIViewChartDTO.dates;
                    this.kpiViewAllClosedVulnerabilities.changeData();
                }
            });

        this.apiService
            .getDashboardByBranchOficceId(
                'kpiVulnerabilitiesByCriticality',
                branchOfficeId,
                isInternal
            )
            .subscribe((response: DashboardResponse) => {
                if (response.singleKPIViewChartDTO) {
                    this.kpiVulnerabilitiesByCriticality.data.name =
                        response.singleKPIViewChartDTO.name;
                    this.kpiVulnerabilitiesByCriticality.data.series =
                        response.singleKPIViewChartDTO.CVSS.series;
                    this.kpiVulnerabilitiesByCriticality.data.dates =
                        response.singleKPIViewChartDTO.CVSS.dates;
                    this.kpiVulnerabilitiesByCriticality.changeData();
                }
            });

        this.apiService
            .getDashboardByBranchOficceId(
                'multipleKpiSeriesVulnerabilityVersus',
                branchOfficeId,
                isInternal
            )
            .subscribe((response: DashboardResponse) => {
                if (response.singleKPIViewChartDTO) {
                    this.multipleKpiSeriesVulnerabilityVersus.data.name =
                        response.singleKPIViewChartDTO.name;
                    this.multipleKpiSeriesVulnerabilityVersus.data.categories =
                        response.singleKPIViewChartDTO.categories;
                    this.multipleKpiSeriesVulnerabilityVersus.data.series =
                        response.singleKPIViewChartDTO.series;
                    this.multipleKpiSeriesVulnerabilityVersus.changeData();
                }
            });

        this.apiService
            .getDashboardByBranchOficceId(
                'tableVulnerabilityAssessmentBySupervisorAndSeverity',
                branchOfficeId,
                isInternal
            )
            .subscribe((response: DashboardResponse) => {
                if (response.singleKPIViewChartDTO) {
                    this.tableVulnerabilityAssessmentBySupervisorAndSeverity.name =
                        response.singleKPIViewChartDTO.name;
                    this.tableVulnerabilityAssessmentBySupervisorAndSeverity.data =
                        response.singleKPIViewChartDTO.values;
                    this.tableVulnerabilityAssessmentBySupervisorAndSeverity.changeData();
                }
            });

        this.apiService
            .getDashboardByBranchOficceId(
                'pieVulnerabilitiesBySeverityLevel',
                branchOfficeId,
                isInternal
            )
            .subscribe((response: DashboardResponse) => {
                if (response.singleKPIViewChartDTO) {
                    this.pieVulnerabilitiesBySeverityLevel.data.name =
                        response.singleKPIViewChartDTO.name;
                    this.pieVulnerabilitiesBySeverityLevel.data.labels =
                        response.singleKPIViewChartDTO.labels;
                    this.pieVulnerabilitiesBySeverityLevel.data.series =
                        response.singleKPIViewChartDTO.series;
                    this.pieVulnerabilitiesBySeverityLevel.data.colors =
                        response.singleKPIViewChartDTO.colors;
                    this.pieVulnerabilitiesBySeverityLevel.changeData();
                }
            });

        this.apiService
            .getDashboardByBranchOficceId(
                'pieVulnerabilitiesOpenBySeverityLevel',
                branchOfficeId,
                isInternal
            )
            .subscribe((response: DashboardResponse) => {
                if (response.singleKPIViewChartDTO) {
                    this.pieVulnerabilitiesOpenBySeverityLevel.data.name =
                        response.singleKPIViewChartDTO.name;
                    this.pieVulnerabilitiesOpenBySeverityLevel.data.labels =
                        response.singleKPIViewChartDTO.labels;
                    this.pieVulnerabilitiesOpenBySeverityLevel.data.series =
                        response.singleKPIViewChartDTO.series;
                    this.pieVulnerabilitiesOpenBySeverityLevel.data.colors =
                        response.singleKPIViewChartDTO.colors;
                    this.pieVulnerabilitiesOpenBySeverityLevel.changeData();
                }
            });

        this.apiService
            .getDashboardByBranchOficceId(
                'pieVulnerabilitiesClosedBySeverityLevel',
                branchOfficeId,
                isInternal
            )
            .subscribe((response: DashboardResponse) => {
                if (response.singleKPIViewChartDTO) {
                    this.pieVulnerabilitiesClosedBySeverityLevel.data.name =
                        response.singleKPIViewChartDTO.name;
                    this.pieVulnerabilitiesClosedBySeverityLevel.data.labels =
                        response.singleKPIViewChartDTO.labels;
                    this.pieVulnerabilitiesClosedBySeverityLevel.data.series =
                        response.singleKPIViewChartDTO.series;
                    this.pieVulnerabilitiesClosedBySeverityLevel.data.colors =
                        response.singleKPIViewChartDTO.colors;
                    this.pieVulnerabilitiesClosedBySeverityLevel.changeData();
                }
            });
    }
}
